import { Reducer } from "redux";

import CustomerState from "./CustomerState";
import { CustomerActionTypes, CustomerActions } from "./CustomerActionTypes";

const initialState: CustomerState = {
  customer: { }
};

const CustomerReducer: Reducer<CustomerState, CustomerActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CustomerActionTypes.SET_CUSTOMER: {
      let newCustomer = action.data;

      return {
        ...state,
        customer: newCustomer
      };
    }
    default: {
      return state;
    }
  }
};

export default CustomerReducer;
